import { connect } from 'react-redux'

import { authenticatedSelector } from '../../reducers/userReducer'
import { purchaseResultSelector } from '../libs/selectors'
import GuestPurchaseItemPage from '../purchase/GuestPurchaseItemPage'
import MemberPurchaseItemPage from '../purchase/MemberPurchaseItemPage'
import PurchaseInstalmentPage from '../purchase/PurchaseInstalmentPage'
import PurchasePeriodicPage from '../purchase/PurchasePeriodicPage'
import PurchaseResultPage from '../purchase/PurchaseResultPage'

function BuyerPaymentEntry(props) {
  const { buyerInstalments, buyerPeriodic, item, purchaseResult } = props

  // 如果經過 OTP 導向回傳的 redirect_url
  if (purchaseResult?.redirect_url) {
    window.location.href = purchaseResult.redirect_url
  } else if (purchaseResult && !purchaseResult.stayAtPurchase) {
    return (
      <PurchaseResultPage
        purchaseResult={purchaseResult}
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    )
  }

  // buyerPeriodic overdue payment
  if (buyerPeriodic) {
    return (
      <PurchasePeriodicPage
        orderNo={buyerPeriodic.order_no}
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    )
  }

  if (buyerInstalments) {
    return (
      <PurchaseInstalmentPage
        orderNo={buyerInstalments.order_number}
        instalmentInfo={buyerInstalments}
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    )
  }

  if (!item) {
    return null
  }

  if (props.authenticated) {
    return (
      <MemberPurchaseItemPage
        itemId={item.cream_item_id}
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    )
  }
  return (
    <GuestPurchaseItemPage
      itemId={item.cream_item_id}
      toPurchaseLoginPage={props.toPurchaseLoginPage}
    />
  )
}

export default connect(state => ({
  purchaseResult: purchaseResultSelector(state.tapPay),
  authenticated: authenticatedSelector(state.user),
  item: state.itemEntry.item,
  buyerInstalments: state.itemEntry.buyerInstalments,
  buyerPeriodic: state.itemEntry.buyerPeriodic,
}))(BuyerPaymentEntry)
